<mat-drawer-container class="container">
  <mat-drawer-content class="container__main-panel">
    <main-panel>
      <ng-content />
    </main-panel>
  </mat-drawer-content>

  <mat-drawer
    class="container__right-panel"
    [opened]="rightPanelVisibility$ | async"
    [mode]="mobileQuery.matches ? 'over' : 'side'"
    (closed)="closeRightVisibility()"
    position="end">
    @if (rightPanelVisibility$ | async) {
      <right-panel />
    }
  </mat-drawer>
</mat-drawer-container>
